import React, { useState } from "react";
import { MessageSquare } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from "@/components/ui/accordion";

export const InquiriesSection = ({ inquiries, archiveInquiry }) => {
  const [inquiryPage, setInquiryPage] = useState(1);
  const [showArchived, setShowArchived] = useState(false);
  const inquiriesPerPage = 5;

  const filteredInquiries = inquiries.filter((inq) =>
    showArchived ? inq.is_archived : !inq.is_archived,
  );
  const paginatedInquiries = filteredInquiries.slice(
    0,
    inquiryPage * inquiriesPerPage,
  );

  return (
    <AccordionItem
      value="inquiries"
      className="bg-background border border-border rounded-lg"
    >
      <AccordionTrigger className="px-4 sm:px-6 py-4 hover:no-underline">
        <div className="flex items-center gap-3">
          <MessageSquare className="w-5 h-5 text-primary" />
          <span className="font-bold text-base">
            Consultas Recibidas (
            {inquiries.filter((i) => !i.is_archived).length})
          </span>
        </div>
      </AccordionTrigger>
      <AccordionContent>
        <div className="px-4 sm:px-6 pb-4 space-y-3 max-h-[500px] overflow-y-auto">
          <div className="flex gap-2 mb-3">
            <Button
              variant={!showArchived ? "default" : "outline"}
              size="sm"
              onClick={() => setShowArchived(false)}
            >
              Activas ({inquiries.filter((i) => !i.is_archived).length})
            </Button>
            <Button
              variant={showArchived ? "default" : "outline"}
              size="sm"
              onClick={() => setShowArchived(true)}
            >
              Archivadas ({inquiries.filter((i) => i.is_archived).length})
            </Button>
          </div>
          {paginatedInquiries.map((inq) => (
            <div
              key={inq.id}
              className="p-3 bg-muted/30 rounded-lg border border-border"
            >
              <div className="flex flex-col sm:flex-row justify-between items-start gap-2">
                <div className="min-w-0 flex-1">
                  <p className="font-medium text-sm">{inq.name}</p>
                  <p className="text-xs text-muted-foreground truncate">
                    {inq.email} | {inq.phone}
                  </p>
                  <p className="text-sm mt-1 break-words">{inq.message}</p>
                </div>
                {!inq.is_archived && archiveInquiry && (
                  <Button
                    size="sm"
                    variant="ghost"
                    onClick={() => archiveInquiry(inq.id)}
                  >
                    Archivar
                  </Button>
                )}
              </div>
            </div>
          ))}
          {filteredInquiries.length > paginatedInquiries.length && (
            <Button
              variant="outline"
              size="sm"
              className="w-full"
              onClick={() => setInquiryPage((p) => p + 1)}
            >
              Ver más
            </Button>
          )}
          {filteredInquiries.length === 0 && (
            <p className="text-center text-sm text-muted-foreground py-4">
              No hay consultas
            </p>
          )}
        </div>
      </AccordionContent>
    </AccordionItem>
  );
};
